import { render, staticRenderFns } from "./indexabroad.vue?vue&type=template&id=3352ef23&scoped=true"
import script from "./indexabroad.vue?vue&type=script&lang=js"
export * from "./indexabroad.vue?vue&type=script&lang=js"
import style0 from "./indexabroad.vue?vue&type=style&index=0&id=3352ef23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352ef23",
  null
  
)

export default component.exports